import React, { useCallback, useEffect, useState } from 'react';
import s from './s.module.less';
import AiTextEditor from 'components/AI/AiTextEditor';
import { EAIEditorType } from 'types/ai';

interface IProps {
    options?: string[],
    value?: string,
    onChange?: (v: string) => void;
    conversationId?: string;
}

const HeadlinesEditor = ({
    options,
    value,
    onChange,
    conversationId,
}: IProps) => {
    const [val, setVal] = useState('');

    useEffect(() => {
        if (value) {
            setVal(value);
        }
    }, [value]);

    const handleClick = useCallback((v: string) => {
        if (v !== val) {
            setVal(v);
            onChange?.(v);
        }
    }, [onChange, val]);

    const handleTextChange = useCallback((v) => {
        setVal(v);
        onChange?.(v);
    }, []);

    return (
        <div className={s.wrap}>
            {
                options && options.length > 0 ? (
                    <>
                        <div className={s.optionsBox}>
                            {
                                options.map((e, index) => {
                                    return (
                                        <div className={`${s.option} ${val === e ? s.selected : ''}`} key={index} onClick={() => handleClick(e)}>
                                            <div className={s.text}>{e}</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <AiTextEditor
                            value={val}
                            className={s.textArea}
                            showCount
                            maxLength={220}
                            onChange={handleTextChange}
                            type={EAIEditorType.HEADLINES}
                            placeholder="Need help crafting your headline? Let Ava suggest a professional title that reflects your credentials."
                            conversionId={conversationId}
                        />
                    </>
                ) :
                    <AiTextEditor
                        value={val}
                        className={s.textArea}
                        showCount
                        maxLength={220}
                        onChange={handleTextChange}
                        type={EAIEditorType.HEADLINES}
                        placeholder="Need help crafting your headline? Let Ava suggest a professional title that reflects your credentials."
                        conversionId={conversationId}
                    />
            }
        </div>
    );
};

export default HeadlinesEditor;
